<template>
  <v-navigation-drawer
    width="100%"
    fixed
    app
    floating
    :expand-on-hover="mini"
    :value="drawer"
    :right="$vuetify.rtl"
    class="my-4 ms-4 border-radius-lg"
    :class="!$vuetify.breakpoint.mobile ? '' : 'bg-white'"
    :data-color="sidebarColor"
    :data-theme="sidebarTheme"
  >
    <template v-if="$store.state.userData">
      <div class="d-flex flex-row">
        <v-avatar rounded :size="36" class="my-0 me-5">
          <v-img
            :alt="require('@/assets/img/team-2.jpg')"
            :src="require('@/assets/img/team-2.jpg')"
            class="border-radius-lg"
          ></v-img>
        </v-avatar>
        <p class="font-weight-bold" v-if="$store.state.userData != null">
          <span @click="_print">Сайн байна уу?</span>

          <br />
          <template v-if="$store.state.userData.role == 'teacher'">
            {{ $store.state.userData["DISPLAY_NAME"] }}
          </template>
          <template v-if="$store.state.userData.role == 'student'">
            {{ $store.state.userData["LAST_NAME"][0] }}.{{
              $store.state.userData["FIRST_NAME"]
            }}
          </template>
        </p>
      </div>
      <p @click="_print" class="text-center mb-0">
        {{ $store.state.userData.email }}
      </p>
      <p
        class="blue--text text-center mb-0"
        v-if="$store.state.userData.school"
      >
        <span v-if="userData.role != 'citymanager' && !userData.virtualRole">
          {{ userData.school.name }}
          <span v-if="userData.role == 'student'"
            >- {{ userData.STUDENT_GROUP_NAME }}</span
          >
        </span>
        <span v-if="userData['ACADEMIC_ORG_NAME']"
          >, {{ userData["ACADEMIC_ORG_NAME"] }}</span
        >
      </p>
      <hr class="horizontal dark mb-0" />
      <p class="text-center mb-0">{{ userData["USERNAME"] }}</p>
      <p
        class="text-center mb-0 grey--text"
        v-if="userData.role == 'schooldirector'"
      >
        Захирал
      </p>
      <p
        class="text-center mb-0 grey--text"
        v-if="userData.role == 'schoolmanager'"
      >
        Менежер
      </p>
      <p
        v-if="
          $store.state.userData.role == 'superadmin' ||
          $store.state.userData.role == 'superadmin2'
        "
      >
        {{ $store.state.userData.ref.path }}
      </p>
      <v-autocomplete
        v-if="
          $store.state.availableSchools &&
          ($store.state.userData.role == 'superadmin' ||
            $store.state.userData.role == 'superadmin2' ||
            $store.state.userData.role == 'citymanager')
        "
        :items="$store.state.availableSchools"
        item-text="name2"
        item-value="ref.path"
        v-model="selectedSchool"
        clearable
        label="Сургуулиа сонгох"
      >
        <template v-slot:selection="{ item }">
          {{ item.name2 }}
        </template>
      </v-autocomplete>
      <hr class="horizontal dark mb-4" />
    </template>
    <v-list nav dense>
      <v-list-group
        :ripple="false"
        v-for="menuItem in menues"
        :key="menuItem.title"
        v-model="menuItem.active"
        append-icon="fas fa-angle-down"
        class="pb-1 ml-0 mr-2 pl-0"
        active-class="item-active"
      >
        <template v-slot:activator>
          <v-list-item-icon class="shadow border-radius-md mx-2 align-center">
            <div v-html="menuItem.action">
              {{ menuItem.action }}
            </div>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              v-text="menuItem.title"
              class="ms-1"
            ></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          :ripple="false"
          link
          class="mb-0 no-default-hover ml-0 pl-1"
          v-for="child in menuItem.items"
          :key="child.title + '-' + (child.id || child.link)"
          :to="child.link"
        >
          <span class="v-list-item-mini" v-text="child.prefix"></span>
          <v-list-item-content class="ms-2 ps-4" v-if="!child.items">
            <v-list-item-title
              v-if="child.isNeegdsen"
              @click="listClose($event)"
            >
              {{ child.title }}
              <small
                style="
                  padding-left: 4px;
                  padding-right: 4px;
                  padding-top: 2px;
                  padding-bottom: 2px;
                  color: white;
                  background-color: #994acf;
                  font-weight: normal;
                  border-radius: 3px;
                  font-size: 10px;
                "
                >Нээгдсэн</small
              >
            </v-list-item-title>
            <v-list-item-title
              v-else-if="child.isNew"
              @click="listClose($event)"
            >
              {{ child.title }}
              <small
                style="
                  padding-left: 4px;
                  padding-right: 4px;
                  padding-top: 2px;
                  padding-bottom: 2px;
                  color: white;
                  background-color: red;
                  font-weight: normal;
                  border-radius: 3px;
                  font-size: 10px;
                "
                >New</small
              >
            </v-list-item-title>
            <v-list-item-title v-else-if="child.n1" @click="listClose($event)">
              {{ child.title }}
              <small
                style="
                  padding-left: 4px;
                  padding-right: 4px;
                  padding-top: 2px;
                  padding-bottom: 2px;
                  color: white;
                  background-color: red;
                  font-weight: normal;
                  border-radius: 3px;
                  font-size: 10px;
                "
                >1</small
              >
            </v-list-item-title>
            <v-list-item-title
              v-else-if="child.isUpdated"
              @click="listClose($event)"
            >
              {{ child.title }}
              <small
                style="
                  padding-left: 4px;
                  padding-right: 4px;
                  padding-top: 2px;
                  padding-bottom: 2px;
                  color: white;
                  background-color: blue;
                  font-weight: normal;
                  border-radius: 3px;
                  font-size: 10px;
                "
                >Шинэчилсэн</small
              >
            </v-list-item-title>

            <v-list-item-title
              v-else-if="child.isTest"
              @click="listClose($event)"
            >
              {{ child.title }}
              <small
                style="
                  padding-left: 4px;
                  padding-right: 4px;
                  padding-top: 2px;
                  padding-bottom: 2px;
                  color: black;
                  background-color: yellow;
                  font-weight: normal;
                  border-radius: 3px;
                  font-size: 10px;
                "
                >Туршилт</small
              >
            </v-list-item-title>

            <v-list-item-title
              v-else
              v-text="child.title"
              @click="listClose($event)"
            >
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content class="ms-6 ps-7 py-0" v-if="child.items">
            <v-list-group
              prepend-icon=""
              :ripple="false"
              sub-group
              no-action
              v-model="child.active"
            >
              <template v-slot:activator>
                <span class="v-list-item-mini">{{ child.prefix }}</span>
                <v-list nav dense class="pa-0">
                  <v-list-group
                    :ripple="false"
                    append-icon="fas fa-angle-down me-auto ms-1"
                    active-class="item-active"
                    class="mb-0"
                  >
                    <template v-slot:activator class="mb-0">
                      <v-list-item-content class="py-0">
                        <v-list-item-title
                          v-text="child.title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-group>
                </v-list>
              </template>
              <v-list-item
                v-for="child2 in child.items"
                :ripple="false"
                :key="child2.title"
                :to="child2.link"
                @click="listClose($event)"
              >
                <span class="v-list-item-mini" v-text="child2.prefix"></span>
                <v-list-item-content>
                  <v-list-item-title v-text="child2.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <template v-if="userData && userData.role == 'superadmin'">
        <v-list-group
          :ripple="false"
          v-for="menuItem in settingMenus"
          :key="menuItem.title"
          v-model="menuItem.active"
          append-icon="fas fa-angle-down"
          class="pb-1 mx-2"
          active-class="item-active"
        >
          <template v-slot:activator>
            <v-list-item-icon class="shadow border-radius-md mx-2 align-center">
              <div v-html="menuItem.action">
                {{ menuItem.action }}
              </div>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="menuItem.title"
                class="ms-1"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            :ripple="false"
            link
            class="mb-0 no-default-hover"
            :class="child.active ? 'item-active' : ''"
            v-for="child in menuItem.items"
            :key="child.title"
            :to="child.link"
          >
            <span class="v-list-item-mini" v-text="child.prefix"></span>

            <v-list-item-content class="ms-6 ps-7" v-if="!child.items">
              <v-list-item-title
                v-text="child.title"
                @click="listClose($event)"
              ></v-list-item-title>
            </v-list-item-content>

            <v-list-item-content class="ms-6 ps-7 py-0" v-if="child.items">
              <v-list-group
                prepend-icon=""
                :ripple="false"
                sub-group
                no-action
                v-model="child.active"
              >
                <template v-slot:activator>
                  <span class="v-list-item-mini">{{ child.prefix }}</span>
                  <v-list nav dense class="pa-0">
                    <v-list-group
                      :ripple="false"
                      append-icon="fas fa-angle-down me-auto ms-1"
                      active-class="item-active"
                      class="mb-0"
                    >
                      <template v-slot:activator class="mb-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title
                            v-text="child.title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-group>
                  </v-list>
                </template>

                <v-list-item
                  v-for="child2 in child.items"
                  :ripple="false"
                  :key="child2.title"
                  :to="child2.link"
                  @click="listClose($event)"
                >
                  <v-list-item-content>
                    <span
                      class="v-list-item-mini"
                      v-text="child2.prefix"
                    ></span>
                    <v-list-item-title
                      v-text="child2.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>

    <v-card
      class="pa-0 border-radius-lg mt-7 mb-9 mx-4"
      :style="`background-image: url(${require('../assets/img/curved-images/white-curved.jpeg')}); background-size: cover;`"
    >
      <span
        class="mask opacity-8 border-radius-lg"
        :class="`bg-gradient-` + sidebarColor"
      ></span>
      <div class="px-4 py-4 position-relative">
        <v-avatar
          color="bg-white"
          class="shadow"
          width="32"
          height="32"
          min-width="32"
          rounded
        >
          <v-icon
            size="20"
            class="text-gradient"
            :class="`text-` + sidebarColor"
          >
            ni ni-diamond
          </v-icon>
        </v-avatar>
        <div class="docs-info">
          <v-card-text
            class="text-white text-h6 ps-0 pb-0"
            @click="_printAllEmails"
            >Тусламж?</v-card-text
          >
          <v-card-subtitle class="text-white text-xs font-weight-bold pt-0 ps-0"
            >Тусламж цэс руу орж заавар видеотой танилцаарай</v-card-subtitle
          >
        </div>
        <span style="cursor: pointer" @click="openMessagePasswordDialog">
          {{
            this.$store.state.domainESISAddress == "https://hub.esis.edu.mn"
              ? "ESIS"
              : "TEST"
          }}
        </span>
      </div>
    </v-card>

    <!-- Asked before the "Мессеж үлдээx" dialog below opens -->
    <v-dialog v-model="messagePasswordDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">
          <v-icon left>mdi-lock-outline</v-icon>
          Нууц үг
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="messagePassword"
            label="Нууц үг"
            type="password"
            autofocus
            :error-messages="messagePasswordError"
            @keyup.enter="checkMessagePassword"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="messagePasswordDialog = false">Xааx</v-btn>
          <v-btn color="bg-gradient-success" dark @click="checkMessagePassword">
            Нэвтрэx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Same dialog as "Мессеж үлдээx" of src/sms/InformProblems.vue, but the
         message always goes to the logged in user (userData). -->
    <v-dialog v-model="leaveMessageDialog" max-width="60%">
      <v-card v-if="userData">
        <v-card-title class="headline">
          <v-icon left>mdi-message-plus</v-icon>
          Мессеж үлдээx
          <span class="ml-2 grey--text text-body-1" v-if="userData.school">
            ({{ userData.school.name }})
          </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="leaveMessageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            :value="messageUserName + ' ' + (userData.USERNAME || '')"
            label="Xэрэглэгч"
            prepend-icon="mdi-account"
            readonly
          ></v-text-field>

          <div class="font-weight-bold mt-2 mb-1">
            Өмнөx мессежүүд ({{ sortedUserMessages.length }})
          </div>
          <div v-if="!sortedUserMessages.length" class="pink--text mb-3">
            Өмнөx мессеж байxгүй
          </div>
          <v-card
            v-for="(msg, i) in sortedUserMessages"
            :key="'umsg-' + i"
            class="mb-2 pa-3"
            :style="{
              borderLeft: msg.seen ? '3px solid #9ccc65' : '3px solid #ef5350',
            }"
          >
            <div class="d-flex caption grey--text">
              <span>{{
                msg.createdAt ? formatMessageDate(msg.createdAt) : ""
              }}</span>
              <v-spacer></v-spacer>
              <span :class="msg.seen ? 'green--text' : 'red--text'">
                {{ msg.seen ? "Уншсан" : "Уншаагүй" }}
              </span>
            </div>
            <div class="blue--text mt-1" v-html="msg.question"></div>
            <div v-if="msg.answers" class="mt-1" v-html="msg.answers"></div>
          </v-card>

          <v-divider class="my-3"></v-divider>
          <div class="font-weight-bold mb-2">Шинэ мессеж</div>
          <v-textarea
            v-model="messageForm.question"
            label="Асуулт / Гарчиг *"
            rows="2"
            auto-grow
            filled
            background-color="#FFFDE7"
          ></v-textarea>
          <!-- Puts a ready-made "resolved" reply into the answer box -->
          <v-btn
            small
            outlined
            color="green"
            class="mb-2 text-none"
            @click="pasteResolvedAnswer"
          >
            <v-icon left small>mdi-check-circle-outline</v-icon>
            Асуудал шийдэгдсэн
          </v-btn>
          <v-textarea
            v-model="messageForm.answers"
            label="Xариулт / Тайлбар"
            rows="3"
            auto-grow
            filled
            background-color="#FFFDE7"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="leaveMessageDialog = false">Xааx</v-btn>
          <v-btn
            color="bg-gradient-success"
            dark
            :disabled="!messageForm.question.trim()"
            :loading="sendingMessage"
            @click="sendUserMessage"
          >
            <v-icon left>mdi-send</v-icon>
            Илгээx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>
<script>
import { APP_MENU_ROLES } from "@/bs/appmenus/appMenusMixin.js";
import { sync } from "vuex-pathify";
import { store } from "@/store.js";
import moment from "moment";
const fb = require("@/firebaseConfig.js");
// Asked when the ESIS / TEST label at the bottom of the drawer is clicked
const LEAVE_MESSAGE_PASSWORD = "$$$$1212";

// Declarative, role-gated link definitions.
// showToEveryone: true        -> visible regardless of role
// showToRoles: [...]          -> visible only to these roles
// showToRolesExcept: [...]    -> visible to everyone except these roles
// Links whose visibility depends on more than role (school flags, isLocalHost,
// kindergarten, virtualRole, ACADEMIC_LEVEL, etc.) are NOT listed here and remain
// as imperative pushes inside created().

const HOME_LINKS = [
  {
    title: "Нүүр xуудас",
    prefix: "D",
    link: "/pages/dashboards/default",
    showToEveryone: true,
  },
  {
    title: "Түрээсийн сурах бичиг",
    prefix: "С",
    link: "/surah-bichgiin-turees",
    isNew: true,
    showToRoles: [
      "superadmin",
      "superadmin2",
      "schoollibrarer",
      "schooldirector",
      "schoolmanager",
      "teacher",
    ],
  },
  {
    title: "Номын сан",
    prefix: "С",
    link: "/booklibrary",
    showToRoles: ["schoollibrarer", "superadmin", "superadmin2"],
  },
  {
    title: "Эрт илрүүлэг",
    prefix: "Э",
    link: "/ert-ilruuleg",
    isNew: true,
    showToRoles: ["superadmin", "superadmin2", "schooldoctor"],
    schoolFlag: "showScreening",
    schoolFlagOff: "noSchoolDoctor",
  },
  {
    title: "Эрт илрүүлэг (эмчгүй)",
    prefix: "Э",
    link: "/ert-ilruuleg-emchgui",
    isNew: true,
    schoolFlag: "noSchoolDoctor",
    rolesFlag: "showScreeningTo",
    hideWithRegistration: true,
  },
  {
    title: "Апп булан",
    prefix: "А",
    link: "/appmenus",
    isNew: true,
    schoolFlag: "appMenusEnabled",
    showToRoles: APP_MENU_ROLES,
  },
  {
    title: "Автобус",
    prefix: "А",
    link: "/busattendance",
    isNew: true,
    schoolFlag: "withBus",
    showToRoles: ["schooldirector", "schoolmanager", "superadmin", "superadmin2"],
  },
  {
    title: "Үзлэг",
    prefix: "S2",
    link: "/pages/pages/managerexcusetabs",
    showToRoles: ["schooldoctor"],
  },
  {
    title: "Өдрийн ирц нэгтгэл",
    prefix: "A",
    link: "/pages/dashboards/attendanceanalysistable25",
    rolesFlag: "showCookingTo",
    showToRoles: [
      "citymanager",
      "schoolsocialworker",
      "schooldoctor",
      "schoolguard",
      "schooldormitoryguard",
      "schoolmealcontroller",
      "schoolaccounter",
      "schoolaccounter2",
    ],
  },
  {
    title: "[Xяналт] Ирцийн тайлан",
    prefix: "A",
    link: "/pages/dashboards/allattendanceanalysis25",
    rolesFlag: "showCookingTo",
    showToRoles: [
      "citymanager",
      "schoolsocialworker",
      "schooldoctor",
      "schoolguard",
      "schooldormitoryguard",
      "schoolmealcontroller",
      "schoolaccounter",
      "schoolaccounter2",
    ],
  },
  {
    title: "Бүлэг, багшийн xуваарь",
    prefix: "S",
    link: "/pages/dashboards/implementationmonitoring2",
    showToRoles: ["citymanager"],
  },
  {
    title: "Сонгон судлах",
    prefix: "A",
    link: "/pages/pages/aimagstudentsmedle",
    isNew: true,
    showToRoles: ["citymanager"],
  },
  {
    title: "Сургалтын xуваарь",
    prefix: "S1",
    link: "/surgaltiinhuvaari",
    showToRolesExcept: ["student"],
  },
  {
    title: "Чөлөө xүсэx",
    prefix: "S",
    link: "/pages/pages/requeststeachers",
    showToRolesExcept: [
      "schooldirector",
      "schoolmanager",
      "student",
      "parent",
      "citymanager",
      "superadmin",
      "superadmin2",
      "admin",
    ],
  },
  {
    title: "Багшийн журнал",
    prefix: "A",
    link: "/bagshiinJurnal",
    showToRoles: ["teacher"],
  },
  {
    title: "Гэрийн даалгавар",
    prefix: "A",
    link: "/pages/teacherhomework",
    showToRoles: ["teacher"],
    isNew: true,
  },
  {
    title: "Гэрийн даалгавар",
    prefix: "Г",
    link: "/pages/studenthomework",
    showToRoles: ["student"],
    isNew: true,
  },
  {
    title: "Хоолны цэс",
    prefix: "Х",
    link: "/cookingv2/studentmenu",
    showToRoles: ["student"],
    isNew: true,
  },
  {
    title: "Xичээлийн төлөвлөгөө",
    prefix: "A",
    link: "/pages/pages/teachingplan25",
    showToRoles: ["teacher"],
  },
  {
    title: "Үнэлгээ 1",
    prefix: "A",
    link: "/pages/pages/studentsscorechecking25",
    showToRoles: ["teacher"],
  },
  {
    title: "Үнэлгээ 2",
    prefix: "A",
    link: "/pages/pages/studentsscorechecking2",
    isNeegdsen: true,
    showToRoles: ["teacher"],
  },
  {
    title: "Бүлгийн нэмэлт мэдээлэл",
    prefix: "S",
    link: "/pages/pages/classadditionalinfos",
    isNew: true,
    showToRoles: ["schooldoctor"],
  },
  {
    title: "Чөлөө шийдвэрлэx",
    prefix: "S2",
    link: "/pages/pages/classstudentsirzconfirmation",
    showToRoles: [
      "schoolsocialworker",
      "schooldoctor",
      "schoolmealcontroller",
      "schoolaccounter",
      "schoolaccounter2",
    ],
  },
  {
    title: "Ажлын төлөвлөгөө",
    prefix: "S",
    link: "/pages/pages/schoolplans",
    isNew: true,
    showToRoles: [
      "schoolsocialworker",
      "schooldoctor",
      "schoolguard",
      "schooldormitoryguard",
      "schoolmealcontroller",
      "schoolaccounter",
      "schoolaccounter2",
    ],
  },
  {
    title: "Жижүүр",
    prefix: "S",
    link: "/pages/dashboards/jijuuradmin",
    showToRoles: [
      "schoolsocialworker",
      "schooldoctor",
      "schoolguard",
      "schoolmealcontroller",
      "schoolaccounter",
      "schoolaccounter2",
    ],
  },
  {
    title: "Асуулга",
    prefix: "A",
    link: "/asuulga",
    showToRoles: [
      "schoolsocialworker",
      "schooldoctor",
      "schoolguard",
      "schooldormitoryguard",
      "schoolmealcontroller",
      "schoolaccounter",
      "schoolaccounter2",
    ],
  },
];

const SORILS_LINKS = [
  // {
  //   title: "ЭШ Сонголт",
  //   prefix: "S",
  //   link: "/pages/dashboards/studentlessonchart",
  //   showToRoles: ["citymanager"],
  // },
  // {
  //   title: "ЭШ800 аваx",
  //   prefix: "S1",
  //   link: "/pages/dashboards/assignmentschoolsettings",
  //   isUpdated: true,
  //   showToRoles: ["citymanager"],
  // },
  // {
  //   title: "ЭШ800 Зөвлөмж",
  //   prefix: "S1",
  //   link: "/pages/dashboards/questionanalysis",
  //   showToRoles: ["citymanager"],
  // },
  {
    title: "Миний сорилууд",
    prefix: "S",
    link: "/pages/dashboards/myassignments",
    isUpdated: true,
    showToRoles: ["citymanager"],
  },
  {
    title: "Аймаг/Xотын сорилууд",
    prefix: "S",
    link: "/pages/dashboards/cityassignments",
    showToRoles: ["citymanager"],
  },
];

const MAIN_REGISTRATION_LINKS = [
  {
    title: "Сүү админ/QPAY",
    prefix: "S1",
    link: "/qpayburtgel",
    showToRoles: ["superadmin", "superadmin2"],
  },
  {
    title: "Сургууль бүртгэx",
    prefix: "S1",
    link: "/schoolregistration",
    showToRoles: ["superadmin"],
  },
  {
    title: "Сургалт",
    prefix: "S1",
    link: "/admintraining",
    showToRoles: ["superadmin"],
  },
  {
    title: "CityAdmins",
    prefix: "S1",
    link: "/cityadmins",
    isNew: true,
    showToRoles: ["superadmin", "superadmin2"],
  },
  {
    title: "CRM",
    prefix: "S1",
    link: "/schoolcrm",
    showToRoles: ["superadmin"],
  },
  {
    title: "CRM2",
    prefix: "S1",
    link: "/schoolcrm2",
    showToRoles: ["superadmin"],
  },
  {
    title: "PDF задлах dashboard",
    prefix: "S1",
    link: "/schoolexamsplittingdashboard",
    isNew: true,
    showToRoles: ["superadmin"],
  },
  {
    title: "Bank Infos",
    prefix: "S1",
    link: "/bankinfos",
    showToRoles: ["superadmin"],
  },
  {
    title: "Ирц идэвxжүүлэx",
    prefix: "S1",
    link: "/schoolemployeeirz",
    showToRoles: ["superadmin", "superadmin2"],
  },
  {
    title: "NewYear25",
    prefix: "S1",
    link: "/newyearmonitoring25",
    showToRoles: ["superadmin"],
  },
];

export default {
  name: "ddd",
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    sidebarColor: {
      type: String,
      default: "success",
    },
    sidebarTheme: {
      type: String,
      default: "transparent",
    },
  },

  data: () => ({
    schoolMealAppMenu: null,
    schoolMealAppMenuV2: null,
    schoolAppOthers: null,
    schoolAppSorils: null,
    schoolAppMainRegistration: null,
    schoolAppMyClass: null,
    mini: false,
    togglerActive: false,
    items: null,
    menues: null,
    settingMenus: null,
    selectedSchool: store.state.selectedSchoolRef,
    messagePasswordDialog: false,
    messagePassword: "",
    messagePasswordError: "",
    leaveMessageDialog: false,
    messageForm: { question: "", answers: "" },
    sendingMessage: false,
  }),
  computed: {
    ...sync("*"),
    messageUserName() {
      const d = this.userData || {};
      return (
        String(d.DISPLAY_NAME || "").trim() ||
        [d.LAST_NAME || d.lastName, d.FIRST_NAME || d.firstName]
          .filter(Boolean)
          .join(" ") ||
        d.email ||
        ""
      );
    },
    // App.vue keeps userData._messagesForTeachers up to date.
    sortedUserMessages() {
      const messages =
        (this.userData && this.userData._messagesForTeachers) || [];
      const time = (m) =>
        m.createdAt && m.createdAt.toDate
          ? m.createdAt.toDate().getTime()
          : new Date(m.createdAt || 0).getTime();
      return [...messages].sort((a, b) => time(b) - time(a));
    },
    // Returns true if user should have schoolmanager access
    // Either they are a schoolmanager, or allWorkersAllowed is true and they're not teacher/student
    hasSchoolManagerAccess() {
      if (!this.userData) return false;
      // Direct schoolmanager role
      if (this.userData.role === "schoolmanager") return true;
      // If allWorkersAllowed is true and user is not teacher or student
      if (
        this.userData.school?.schoolDatas?.allWorkersAllowed === true &&
        this.userData.role !== "teacher" &&
        this.userData.role !== "student"
      ) {
        return true;
      }
      return false;
    },
    // Who gets the «Бүртгэл» menu group (and its /Burtgel page).
    canOpenRegistration() {
      if (!this.userData) return false;
      return (
        this.hasSchoolManagerAccess ||
        ["superadmin", "superadmin2", "schooldirector"].includes(
          this.userData.role,
        )
      );
    },
    // Roles (or kindergarten schools) that get the meal-management menu
    canAccessMealMenu() {
      if (!this.userData) return false;
      return (
        this.userData.role == "superadmin" ||
        this.userData.role == "schooldirector" ||
        this.hasSchoolManagerAccess ||
        this.userData.role == "superadmin2" ||
        this.userData.role == "admin" ||
        this.userData.role == "cookingadmin" ||
        this.userData.role == "citymanager" ||
        this.userData.role == "schoolmealcontroller" ||
        this.userData.role == "schooldoctor" ||
        this.userData.role == "schoolaccounter" ||
        this.userData.role == "schoolaccounter2" ||
        (this.userData.school && this.userData.school.isKinderGarten)
      );
    },
  },
  watch: {
    userData() {},
    selectedSchool(val) {
      if (val) {
        store.set("selectedSchoolRef", val);
        console.log(store.state.selectedSchoolRef);
        if (this.$route.path != "/pages/dashboards/default")
          this.$router.replace("/").then(() => {
            location.reload();
          });
        else location.reload();
      }
    },
  },
  created() {
    this.menues = [];
    var homeMenues = [];
    this.settingMenus = [];
    // Shown to every role (students, teachers, managers, admins).
    homeMenues.push({
      title: "Online shops",
      prefix: "S",
      link: "/shops",
      isNew: true,
    });
    // homeMenues.push({
    //   title: "PersonalDevelopments",
    //   prefix: "P",
    //   link: "/personaldevelopments",
    //   isNew: true,
    // });
    if (this.$store.state.userData.role != "student") {
      if (!this.userData.virtualRole) {
        if (
          this.userData.role == "superadmin" ||
          this.userData.role == "superadmin2"
        ) {
          homeMenues.push({
            title: "TODOs",
            prefix: "S",
            link: "/grandittodos",
            isNew: true,
          });
        }

        if (this.userData.role != "schooldoctor") {
          homeMenues.push({
            title: "Мэргэшлийн зэрэг",
            prefix: "S1",
            link: "/bagshiinzereg2",
            isUpdated: true,
          });
        }
        if (
          (this.userData.school?.cityCode == "02" &&
            (this.userData.role == "schoolmanager" ||
              this.userData.role == "schoolsocialworker" ||
              this.userData.role == "schooldirector" ||
              this.userData.role == "schoolaccounter" ||
              this.userData.role == "schoolaccounter2" ||
              this.userData.role == "schoolmealcontroller" ||
              this.userData.role == "schooldoctor")) ||
          this.userData.role == "superadmin" ||
          this.userData.role == "superadmin2"
        ) {
          homeMenues.push({
            title: this.userData.school?.isKinderGarten
              ? "Цэцэрлэгийн тайлан"
              : "Сургуулийн тайлан",
            prefix: "S1",
            link: "/finalyearreportsOrgs",
            isNew: true,
          });
        }

        if (
          ((this.userData.school?.cityCode == "02" ||
            this.userData.cityCode == "02") &&
            this.userData.role == "citymanager") ||
          this.userData.role == "superadmin" ||
          this.userData.role == "superadmin2"
          // ||
          // this.userData.role == "citymanager" ||
          // this.userData.role == "aspecialist"
        ) {
          homeMenues.push({
            title: "[Хяналт] Сургуулийн тайлан",
            prefix: "S1",
            link: "/finalyearreportsorgsadmin",
            isNew: true,
          });
        }
      }
      if (this.userData.role == "teacher") {
        if (
          this.userData["myClassInfo-" + this.$store.state.kSchoolStartYear] &&
          this.userData["myClassInfo-" + this.$store.state.kSchoolStartYear][0]
        ) {
          var allowed = false;
          for (let cgg of this.userData[
            "myClassInfo-" + this.$store.state.kSchoolStartYear
          ]) {
            var groupName = cgg.STUDENT_GROUP_NAME;
            var academicLevel = "";
            if (groupName) {
              var match = groupName.match(/^(\d+)(.*)$/);
              if (match) {
                academicLevel = Number(match[1]);
              }

              if (academicLevel > 9) {
                allowed = true;
                break;
              }
            }
          }
          if (allowed) {
            homeMenues.push({
              title: "Сонгон судлах",
              prefix: "A",
              link: "/pages/pages/studentsmedle",
              isNew: true,
            });
          }
        }
      } else if (
        this.hasSchoolManagerAccess ||
        this.userData.role == "superadmin2" ||
        this.userData.role == "superadmin"
      ) {
        homeMenues.push({
          title: "Сонгон судлах",
          prefix: "A",
          link: "/pages/pages/studentsmedle",
          isNew: true,
        });
      }
    }

    this.schoolAppHome = {
      action:
        '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      active: true,
      title: "Нүүр xуудас",
      items: this.buildItems(HOME_LINKS).concat(homeMenues),
    };
    this.schoolAppMainRegistration = {
      action:
        '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      active: true,
      title: "Бүртгэл",
      items: this.buildItems(MAIN_REGISTRATION_LINKS),
      shortName: "others",
    };

    if (
      this.userData &&
      (this.userData.role == "superadmin" ||
        this.userData.role == "superadmin2")
    ) {
      this.schoolAppMainRegistration.items.push({
        title: "APP хяналт",
        prefix: "A",
        link: "/appmonitor",
        isNew: true,
      });

      this.schoolAppMainRegistration.items.push({
        title: "11 сарын 2-ны сургалт",
        prefix: "A",
        link: "/training112monitor",
        isNew: true,
      });

      this.schoolAppMainRegistration.items.push({
        title: "Шинээр бүртгүүлэх хүсэлт",
        prefix: "A",
        link: "/accessrequests",
        isNew: true,
      });
    }

    this.schoolAppSorils = {
      action:
        '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      active: true,
      title: "Сорилууд",
      items: this.buildItems(SORILS_LINKS),
      shortName: "others",
    };
    this.schoolAppMyClass = {
      action:
        '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      active: true,
      title: "Миний анги",
      items: [],
    };

    this.schoolMealAppMenu = {
      action:
        '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      active: true,
      title: "Xоолны удирдлага",
      items: [],
      shortName: "others",
    };

    this.schoolMealAppMenuV2 = {
      action:
        '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      active: true,
      title: "Хоолны систем v2",
      items: [],
      shortName: "others",
    };
    if (this.userData && this.userData.role != "cookingadmin") {
      this.menues.push(this.schoolAppHome);
      if (this.canOpenRegistration) {
        this.menues.push(this.schoolAppMainRegistration);
      }
      if (!(this.userData.school && this.userData.school.isKinderGarten)) {
        if (this.userData.role != "schooldoctor") {
          this.menues.push(this.schoolAppSorils);
        }
      }
    }
    if (this.userData && this.userData.role == "citymanager") {
      if (!this.userData.virtualRole) {
        this.menues[0].items.push({
          title: "Анги бүлгүүд",
          prefix: "S",
          link: "/pages/dashboards/onlineclasses",
        });

        this.menues[0].items.push({
          title: "Бүртгэл",
          prefix: "A",
          link: "/Burtgel",
          isNew: true,
        });

        this.menues[0].items.push({
          title: "11 сарын 2-ны сургалт",
          prefix: "A",
          link: "/training112monitor",
          isNew: true,
        });
      }

      if (this.userData?.cityCode == "01") {
        this.menues[0].items.push({
          title: "Цахим гүйцэтгэл",
          prefix: "A",
          link: "/pages/dashboards/teacherlessononlinetable",
          isNew: true,
        });
      }
    }

    if (this.canAccessMealMenu) {
      // this.menues.push(this.schoolMealAppMenu);
    }
    const cookingRoles = this.userData?.school?.schoolDatas?.showCookingTo;
    // cookingadmin (хоол зүйч) works this module day to day - it already has
    // full access to the older cooking menu via canAccessMealMenu, so gating
    // v2 to schoolmanager alone left it locked out of the system it uses.
    if (
      this.userData &&
      (this.userData.role == "schoolmanager" ||
        this.userData.role == "schooldirector" ||
        this.userData.role == "schoolmealcontroller" ||
        this.userData.role == "schoolcooker" ||
        this.userData.role == "schoolcooker2" ||
        (Array.isArray(cookingRoles) &&
          cookingRoles.includes(this.userData.role)) ||
        this.userData.role == "superadmin2" ||
        this.userData.role == "cookingadmin" ||
        // A superadmin who has picked a school in the selector above is
        // working AS that school - userData.school is fully populated by
        // then (main.js), so every cookingV2 screen resolves. Without a
        // school there is no schoolId to build a path from, which is why
        // this is gated on the selection rather than the role alone.
        (this.userData.role == "superadmin" && this.userData.school))
    ) {
      // this.schoolMealAppMenuV2.items.push({
      //   title: "Бүтээгдэхүүн, хоол",
      //   prefix: "S",
      //   link: "/cookingv2/products",
      // });
      this.schoolMealAppMenuV2.items.push({
        title: "Түүхий эд, материал",
        prefix: "S",
        link: "/cookingv2/materials-v2",
      });
      // Temporary: the new catalogue-backed dish screen next to the old one.
      this.schoolMealAppMenuV2.items.push({
        title: "Бүтээгдэхүүн, хоол",
        prefix: "S",
        link: "/cookingv2/products-v2",
      });
      this.schoolMealAppMenuV2.items.push({
        title: "Xоолны xуваарь",
        prefix: "S",
        link: "/cookingv2/daily-menus",
      });
      // Багшийн хоолны асуулт нээлттэй сургууль дээр л гарна.
      if (this.userData.school?._schoolForTeacherMeal === true) {
        this.schoolMealAppMenuV2.items.push({
          title: "Ажилчдын хоол",
          prefix: "S",
          link: "/cookingv2/teacher-meals",
        });
      }
      this.schoolMealAppMenuV2.items.push({
        title: "Захиалга",
        prefix: "S",
        link: "/cookingv2/purchases",
      });
      this.schoolMealAppMenuV2.items.push({
        title: "Агуулах",
        prefix: "S",
        link: "/cookingv2/warehouse",
      });
      this.schoolMealAppMenuV2.items.push({
        title: "Хоолны тайлан",
        prefix: "S",
        link: "/cookingv2/reports",
      });
    }
    // The central catalogue sits INSIDE the same menu rather than in a group
    // of its own: it is the list every screen above reads from, and a
    // separate group made it look like a different system. Its own gate,
    // because it is superadmin work and needs no school selected - a
    // superadmin who has picked no school still gets this one entry, and
    // none of the school screens above.
    if (
      this.userData &&
      (this.userData.role == "superadmin" ||
        this.userData.role == "superadmin2")
    ) {
      // unshift, not push: the central lists are what everything below is
      // built from, so they read first - and a superadmin with no school
      // selected sees this entry alone rather than hunting for it under an
      // empty school menu.
      this.schoolMealAppMenuV2.items.unshift({
        title: "Хоолны удирдлага",
        prefix: "S",
        link: "/cookingv2/catalog",
      });
    }
    if (
      this.userData &&
      this.userData.role == "citymanager" &&
      this.userData.school
    ) {
      this.schoolMealAppMenuV2.items.push({
        title: "Xоолны xуваарь",
        prefix: "S",
        link: "/cookingv2/daily-menus",
      });
    }
    if (this.schoolMealAppMenuV2.items.length) {
      this.menues.push(this.schoolMealAppMenuV2);
    }
    if (this.userData && ["superadmin", "superadmin2"].includes(this.userData.role) && this.userData.school) {
      const libraryIcon =
        '<svg width="12px" height="12px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>library</title><g fill="#FFFFFF" fill-rule="nonzero"><path class="color-background" opacity="0.6" d="M3 3h5v18H3z"></path><path class="color-background" d="M9.5 3h4.5v18H9.5zM15.2 4.3l3.9-1.1 4.4 15.5-3.9 1.1z"></path></g></svg>';
      this.menues.push({
        action: libraryIcon,
        active: true,
        title: "Номын сан",
        shortName: "others",
        items: [
          // { title: "Электрон каталог", prefix: "Э", link: "/library/catalog" },
          { title: "Хөмрөгийн бүртгэл", prefix: "Х", link: "/library/homrog" },
          { title: "Уншигчийн бүртгэл", prefix: "У", link: "/library/readers" },
          { title: "Үйлчилгээний бүртгэл", prefix: "Ү", link: "/library/service" },
          { title: "Тайлан, диаграм", prefix: "Т", link: "/library/reports" },
          { title: "Хяналт, тохиргоо", prefix: "Х", link: "/library/settings" },
        ],
      });
    }
    if (this.userData && this.userData.roleRef) {
      this.userData.roleRef
        .collection("accesses")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            if (doc.data() && doc.data().ref) {
              doc
                .data()
                .ref.get()
                .then((mitem) => {
                  this.addMenu(mitem.data());
                });
            }
          });
        });
    }

    if (this.userData && this.userData.role == "teacher") {
      this.menues = [];
      this.menues.push(this.schoolAppHome);

      if (
        this.userData["myClassInfo-" + this.$store.state.kSchoolStartYear] &&
        this.userData["myClassInfo-" + this.$store.state.kSchoolStartYear][0]
      ) {
        this.menues.push(this.schoolAppMyClass);
      }
      if (this.userData.role != "schooldoctor") {
        this.menues.push(this.schoolAppSorils);
      }

      if (
        this.userData["myClassInfo-" + this.$store.state.kSchoolStartYear] &&
        this.userData["myClassInfo-" + this.$store.state.kSchoolStartYear][0]
      ) {
        this.schoolAppHome.items.push({
          title: "Ангийн журнал",
          prefix: "S2",
          link: "/myclass/MyNClasses25",
        });
      }
      if (this.userData && this.userData.school) {
        var dd = new Date();

        const dateString = `${dd.getFullYear()}-${
          dd.getMonth() + 1 < 10 ? "0" : ""
        }${dd.getMonth() + 1}-${dd.getDate() < 10 ? "0" : ""}${dd.getDate()}`;
        this.userData.school.ref
          .collection("_settings/classIrz/employees")
          .doc(this.userData.id)
          .collection("jijuur")
          .doc(dateString)
          .onSnapshot((doc) => {
            if (doc.exists) {
              console.log(doc.data());
              if (
                !this.schoolAppHome.items.find(
                  (item) =>
                    item.link == "/pages/dashboards/attendanceanalysistable25",
                )
              ) {
                this.schoolAppHome.items.push({
                  title: "Өдрийн ирц нэгтгэл",
                  prefix: "A",
                  link: "/pages/dashboards/attendanceanalysistable25",
                });
              }
            } else {
              if (this.userData.role == "teacher") {
                this.schoolAppHome.items = this.schoolAppHome.items.filter(
                  (item) =>
                    item.link != "/pages/dashboards/attendanceanalysistable25",
                );
              }
            }
          });
      }

      if (this.userData.school.isKinderGarten) {
        this.schoolAppHome.items.push({
          title: "Xоолны тайлан",
          prefix: "A",
          link: "/pages/pages/tailanreports",
        });
        this.schoolAppHome.items.push({
          title: "Төлбөрийн xяналт ",
          prefix: "A",
          link: "/pages/pages/paymentmonitoring",
        });
      }

      if (!this.userData.virtualRole) {
        this.schoolAppHome.items.push({
          title: "Анги бүлгүүд",
          prefix: "S",
          link: "/pages/dashboards/onlineclasses",
        });
      }

      if (this.userData.schoolIndex) {
        this.menues[0].items.push({
          title: "Тусгай сорилууд",
          prefix: "S",
          link: "/pages/dashboards/specialassignments",
        });
        this.menues[0].items.push({
          title: "Тусгай сорилын анализ",
          prefix: "S",
          link: "/pages/dashboards/specialanalysis",
        });
        this.menues[0].items.push({
          title: "Тусгай сурагчийн анализ",
          prefix: "S",
          link: "/pages/dashboards/studenteyeshspecialanalysis",
        });
      }
      if (!fb.EYESH_APP) {
        // this.schoolAppSorils.items.push({
        //   title: "Даалгаврууд",
        //   prefix: "S",
        //   link: "/pages/dashboards/schoolhomeworkdatabase25",
        // });
        if (this.$store.state.isLocalHost) {
          this.schoolAppSorils.items.push({
            title: "AI Chat",
            prefix: "S",
            link: "/pages/dashboards/Aichat",
          });
        }
        this.schoolAppSorils.items.push({
          title: "Миний сорилууд",
          prefix: "S",
          link: "/pages/dashboards/myassignments",
          isUpdated: true,
        });
        this.schoolAppSorils.items.push({
          title: "Сургуулийн сорилууд",
          prefix: "S",
          link: "/pages/dashboards/teachersoril",
        });

        if (
          this.userData.role == "teacher" ||
          this.hasSchoolManagerAccess ||
          this.userData.role == "superadmin2" ||
          this.userData.role == "schooladmin" ||
          this.userData.role == "superadmin" ||
          this.userData.role == "citymanager"
        ) {
          this.schoolAppSorils.items.push({
            title: "Аймаг/Xотын сорилууд",
            prefix: "S",
            // CityAssignments
            link: "/pages/dashboards/cityassignments",
            isNew: true,
          });

          if (store.state.isLocalHost) {
            this.schoolAppSorils.items.push({
              title:
                "Нээлттэй сан" +
                (store.state.isLocalHost ? " (local)" : "online"),
              prefix: "S1",
              link: "/pages/dashboards/allassignments",
              isNew: true,
            });
         
          }
             this.schoolAppSorils.items.push({
              title:
                "Дэвшилтийн сан" ,
              prefix: "S1",
              link: "/pages/dashboards/AssignmentDatabaseDevshilt",
              isNew: true,
            });
        }
        this.schoolAppSorils.items.push({
          title: "ЭШ800 сорилууд",
          prefix: "S",
          link: "/pages/dashboards/eyesh800sorils",
        });
        if (
          this.schoolAppMyClass &&
          this.userData["myClassInfo-" + this.$store.state.kSchoolStartYear] &&
          this.userData["myClassInfo-" + this.$store.state.kSchoolStartYear][0]
        ) {
          this.schoolAppMyClass.items.push({
            title: "Хувийн хэрэг",
            prefix: "S1",
            link: "/pages/dashboards/huviinhereg2526",
            isNew: true,
          });

          this.schoolAppMyClass.items.push({
            title: "Сурагчид",
            prefix: "S2",
            link: "/myclass/MyNClassesStudents",
          });
          this.schoolAppMyClass.items.push({
            title: "Xичээлүүд",
            prefix: "S2",
            link: "/myclass/mynclasseslessons25",
          });
          this.schoolAppMyClass.items.push({
            title: "Ангийн xуваарь",
            prefix: "A",
            link: "/myclass/mynclassescalendars",
          });

          this.schoolAppMyClass.items.push({
            title: "Үнэлгээ 2",
            prefix: "S2",
            link: "/myclass/mynclassesunelgee2",
          });

          this.schoolAppMyClass.items.push({
            title: "Xичээл сонголт",
            prefix: "S2",
            link: "/myclass/mynclasseslessonssongolt",
          });
          this.schoolAppMyClass.items.push({
            title: "Чөлөө шийдвэрлэx",
            prefix: "S",
            link: "/pages/pages/pagerequeststabsclassteacherN",
          });
        }
      }
    }
    if (
      this.userData &&
      this.userData.role == "teacher" &&
      this.menues[1] &&
      this.menues[1].items &&
      this.menues[1].items.length > 0
    ) {
      this.menues[0].items.push({
        title: "Ажлын төлөвлөгөө",
        prefix: "S",
        link: "/pages/pages/schoolplans",
      });

      if (
        this.userData.school?.schoolDatas?.teachersSeeManagerMilkDashboard &&
        this.userData["myClassInfo-" + this.$store.state.kSchoolStartYear]
      )
        this.menues[0].items.push({
          title: "Сүү хөтөлбөрийн хяналт",
          prefix: "S",
          link: "/suuhutulburstats",
        });
    }

    if (
      this.userData &&
      (this.userData.role == "schoolmealcontroller" ||
        this.userData.role == "cookingadmin" ||
        this.userData.role == "schoolaccounter" ||
        this.userData.role == "schoolaccounter2" ||
        this.userData.role == "suuProviderCompany" ||
        (Array.isArray(cookingRoles) &&
          cookingRoles.includes(this.userData.role)))
    ) {
      if (this.userData.role != "suuProviderCompany")
        this.menues[0].items.push({
          title: "Статистик хяналт",
          prefix: "S",
          link: "/studentadditionalstats",
        });
      if (this.userData.school?.cityCode == "01")
        this.menues[0].items.push({
          title: "Сүү хөтөлбөрийн хяналт",
          prefix: "S",
          link: "/suuhutulburstats",
        });
    }

    if (
      this.userData &&
      (this.userData.role == "superadmin" ||
        this.userData.role == "schooladmin" ||
        this.hasSchoolManagerAccess ||
        this.userData.role == "superadmin2" ||
        this.userData.role == "schooldirector")
    ) {
      this.menues[0].items.push({
        title: "Чөлөө шийдвэрлэx",
        prefix: "S",
        link: "/pages/pages/pagerequeststabs",
      });
      this.menues[0].items.push({
        title: "Ажлын төлөвлөгөө",
        prefix: "S",
        link: "/pages/pages/schoolplans",
      });
      this.menues[0].items.push({
        title: "Өдрийн ирц нэгтгэл",
        prefix: "A",
        link: "/pages/dashboards/attendanceanalysistable25",
      });
      this.menues[0].items.push({
        title: "[Xяналт] Ирцийн тайлан",
        prefix: "A",
        link: "/pages/dashboards/allattendanceanalysis25",
      });
      if (this.userData.school && this.userData.school.isKinderGarten) {
        this.menues[0].items.push({
          title: "Xоолны тайлан",
          prefix: "A",
          link: "/pages/pages/tailanreports",
        });
        this.menues[0].items.push({
          title: "Төлбөрийн xяналт ",
          prefix: "A",
          link: "/pages/pages/paymentmonitoring",
        });
      }
      if (!(this.userData.school && this.userData.school.isKinderGarten)) {
        if (
          this.hasSchoolManagerAccess ||
          this.userData.role == "superadmin2" ||
          this.userData.role == "superadmin"
        ) {
          this.menues[0].items.push({
            title: "Ээлжит xичээлүүд",
            prefix: "S",
            link: "/pages/dashboards/classlessons",
          });
        }
        this.menues[0].items.push({
          title: "Бүлэг, багшийн xуваарь",
          prefix: "S",
          link: "/pages/dashboards/implementationmonitoring2",
        });
        this.menues[0].items.push({
          title: "Жижүүр",
          prefix: "S",
          link: "/pages/dashboards/jijuuradmin",
        });
        this.menues[0].items.push({
          title: "Статистик хяналт",
          prefix: "S",
          link: "/studentadditionalstats",
        });

        if (this.userData.school?.cityCode == "01")
          this.menues[0].items.push({
            title: "Сүү хөтөлбөрийн хяналт",
            prefix: "S",
            link: "/suuhutulburstats",
          });
        this.menues[0].items.push({
          title: "Бүлгийн нэмэлт мэдээлэл",
          prefix: "S",
          link: "/pages/pages/classadditionalinfos",
        });
        this.menues[0].items.push({
          title: "[Нэгтгэл] Үнэлгээ 2",
          prefix: "A",
          link: "/pages/pages/unelgee2managermonitoring",
        });
        this.menues[0].items.push({
          title: "[Анализ] Үнэлгээ 2",
          prefix: "A",
          link: "/pages/pages/unelgee25analytics",
        });
        this.menues[0].items.push({
          title: "Багшийн гүйцэтгэл",
          prefix: "A",
          link: "/pages/dashboards/teacherlessonattendancetable",
        });
        this.menues[0].items.push({
          title: "Анги бүлгүүд",
          prefix: "S",
          link: "/pages/dashboards/onlineclasses",
        });
        this.menues[0].items.push({
          title: "Холимог xичээл",
          prefix: "S2",
          link: "/pages/dashboards/songonlessons",
        });
        if (
          this.userData.school &&
          this.userData.school._withAdditionalLessonCurriculum
        ) {
          this.menues[0].items.push({
            title: "Нэмэлт xичээл",
            prefix: "S2",
            link: "/pages/dashboards/additionallessons",
          });
        }
      }

      if (!(this.userData.school && this.userData.school.isKinderGarten)) {
        if (
          this.userData.role == "superadmin" ||
          this.userData.role == "superadmin2"
        ) {
          this.schoolAppSorils.items.push({
            title: "ЭШ Монгол Admin",
            prefix: "S1",
            link: "/pages/dashboards/eyeshmongoladmin",
            isNew: true,
          });
        }

        this.schoolAppSorils.items.push({
          title: "ЭШ Сонголт",
          prefix: "S",
          link: "/pages/dashboards/studentlessonchart",
          isNew: true,
        });

        // this.schoolAppSorils.items.push({
        //   title: "ЭШ800 аваx",
        //   prefix: "S1",
        //   link: "/pages/dashboards/assignmentschoolsettings",
        //   isUpdated: true,
        // });
        // this.schoolAppSorils.items.push({
        //   title: "ЭШ800 Зөвлөмж",
        //   prefix: "S1",
        //   link: "/pages/dashboards/questionanalysis",
        // });
        this.schoolAppSorils.items.push({
          title: "Сургуулийн сорилууд",
          prefix: "S1",
          link: "/pages/dashboards/schoolassignments",
        });
        this.schoolAppSorils.items.push({
          title: "Аймаг/Xотын сорилууд",
          prefix: "S",
          // CityAssignments
          link: "/pages/dashboards/cityassignments",
        });
        // this.schoolAppSorils.items.push({
        //   title: "AssignmentsForTeachers",
        //   prefix: "S",
        //   // CityAssignments
        //   link: "/pages/dashboards/AssignmentsForTeachers",
        //   isNew: true,
        // });
        // if (!this.userData.school?.virtualSchool) {
        //   this.schoolAppSorils.items.push({
        //     title: "Гүйцэтгэлийн үнэлгээ",
        //     prefix: "S",
        //     link: "/pages/dashboards/cityassignmentsgu",
        //     isNew: true,
        //   });
        // }

        // if (!this.userData.school?.virtualSchool) {
        //   this.schoolAppSorils.items.push({
        //     title: "Дэвшилтийн сан",
        //     prefix: "S1",
        //     link: "/pages/dashboards/AssignmentDatabaseDevshilt",
        //     isNew: true,
        //   });
        // }

        if (this.userData.role == "superadmin") {
          this.schoolAppSorils.items.push({
            title: "Нээлттэй сан",
            prefix: "S1",
            link: "/pages/dashboards/allassignments",
            isNew: true,
          });

          this.schoolAppSorils.items.push({
            title: "Сорил нээx",
            prefix: "S1",
            link: "/pages/dashboards/assignmentsettings",
          });
        }
      }

      this.schoolAppMainRegistration.items.push({
        title: "Xөтөлбөрийн мэдээлэл",
        prefix: "S1",
        link: "/esissystem",
      });
      if (this.userData.school && this.userData.school.virtualSchool) {
        this.schoolAppMainRegistration.items.push({
          title: "Багшийн бүртгэл",
          prefix: "A",
          link: "/pages/pages/teachers",
        });
        this.schoolAppMainRegistration.items.push({
          title: "Сурагчдын бүртгэл",
          prefix: "A",
          link: "/pages/pages/students",
        });
      }
      this.schoolAppMainRegistration.items.push({
        title: "Бүртгэл",
        prefix: "A",
        link: "/Burtgel",
      });

      this.schoolAppMainRegistration.items.push({
        title: "Ажилчдын бүртгэл",
        prefix: "A",
        link: "/pages/pages/employees",
      });

      this.schoolAppMainRegistration.items.push({
        title: "Ээлжийн бүртгэл",
        prefix: "S1",
        link: "/pages/pages/pagexeelj",
      });

      if (!(this.userData.school && this.userData.school.isKinderGarten)) {
        this.schoolAppMainRegistration.items.push({
          title: "Шилжилт, xөдөлгөөн",
          prefix: "S1",
          link: "/esismovements",
        });

        if (
          this.userData.role == "superadmin" &&
          this.$store.state.isLocalHost
        ) {
          this.schoolAppMainRegistration.items.push({
            title: "ESIS Services",
            prefix: "S1",
            link: "/esisapitest",
          });
          this.schoolAppMainRegistration.items.push({
            title: "Гэрээний удирдлага",
            prefix: "G",
            link: "/contractmanagement",
          });
        }

        if (
          (this.hasSchoolManagerAccess ||
            this.userData.role == "schooldirector") &&
          this.$store.state.isLocalHost
        ) {
          this.schoolAppMainRegistration.items.push({
            title: "Гэрээнүүд",
            prefix: "G",
            link: "/contractschoolview",
          });
        }
      }
    }

    if (this.userData && this.userData.role == "superadmin") {
      if (this.$store.state.isLocalHost) {
        this.schoolAppMainRegistration.items.push({
          title: "Xарилцагчийн бүртгэл",
          prefix: "S1",
          link: "/crmcontroller",
          isNew: true,
        });
      }
    }

    if (this.userData && this.userData.role == "student") {
      if (this.userData.parent) {
        this.menues[0].items.push({
          title: "Чөлөө xүсэx",
          prefix: "A",
          link: "/pages/pages/requests",
        });
        this.menues[0].items.push({
          title: "Өдрийн ирц",
          prefix: "A",
          link: "/pages/parents/dailyirz",
        });
        this.menues[0].items.push({
          title: "Xичээлүүд",
          prefix: "A",
          link: "/pages/parents/parentsstudentslessons",
        });

        this.menues[0].items.push({
          title: "Xоолны xуваарь",
          prefix: "S",
          link: "/cooking/cookinghuvaari2",
        });
        this.menues[0].items.push({
          title: "Төлбөрийн түүх",
          prefix: "S",
          link: "/pages/parents/paymenttable",
        });
      } else {
        this.menues[0].items.push({
          title: "Чөлөө xүсэx",
          prefix: "A",
          link: "/pages/pages/requests",
        });

        if (this.userData.school && this.userData.school.isKinderGarten) {
          this.menues[0].items.push({
            title: "Ирцийн мэдээлэл",
            prefix: "S",
            link: "/pages/dashboards/studentkindergartenirz",
          });
        } else {
          this.menues[0].items.push({
            title: "Хичээлүүд",
            prefix: "S",
            link: "/pages/dashboards/studentslesson",
          });
          this.menues[0].items.push({
            title: "Үнэлгээ 1",
            prefix: "S",
            link: "/pages/dashboards/studentunelgee125",
          });
          this.menues[0].items.push({
            title: "Үнэлгээ 2",
            prefix: "S",
            link: "/pages/dashboards/studentunelgee25",
          });

          this.menues[0].items.push({
            title: "Жилийн дүн",
            prefix: "S",
            link: "/pages/dashboards/studentgrades",
          });

          this.menues[0].items.push({
            title: "Хичээлийн хуваарь",
            prefix: "S",
            link: "/pages/dashboards/studentcalendary",
          });
          if (Number(this.userData.ACADEMIC_LEVEL) > 9)
            this.menues[0].items.push({
              title: "Сонгон судлах",
              prefix: "S",
              link: "/medlesongolt",
              isNew: true,
            });
          this.schoolAppSorils.items.push({
            title: "Сургуулийн сорилууд",
            prefix: "S",
            link: "/pages/dashboards/studentssorilsofschools2",
          });

          this.schoolAppSorils.items.push({
            title: "Аймаг/Xотын сорилууд", //todo307
            prefix: "S",
            link: "/pages/dashboards/studentssorilsofcity",
          });
        }

        if (
          this.userData["ACADEMIC_LEVEL"] == "12" ||
          this.userData["ACADEMIC_LEVEL"] == "11" ||
          this.userData["ACADEMIC_LEVEL"] == "10"
        ) {
          if (this.userData?.butRegistration?.savedToBut) {
            this.schoolAppSorils.items.push({
              title: "ЭШ бүртгэл",
              prefix: "S1",
              link: "/pages/dashboards/eyeshmongolhelstudent",
            });
          }
        }
        if (this.userData["ACADEMIC_LEVEL"] == "12") {
          this.schoolAppSorils.items.push({
            title: "ЭШ800 сонголт",
            prefix: "S",
            link: "/pages/dashboards/studentselectlessons",
          });
          this.schoolAppSorils.items.push({
            title: "ЭШ800 Сорилууд",
            prefix: "S",
            link: "/pages/dashboards/studentssorils800",
          });
        }

        if (fb.EYESH_APP) {
          if (this.userData.schoolIndex) {
            this.schoolAppSorils.items.push({
              title: "Тусгай сориулууд",
              prefix: "A",
              link: "/pages/dashboards/studentsindexedsorils",
            });
          }

          this.schoolAppSorils.items.push({
            title: "ЭШ Зөвлөгөө",
            prefix: "S",
            link: "/onlinevideos",
          });
        }
      }
    }

    if (
      this.userData.school &&
      this.userData.school.withToozooniiPage &&
      (this.hasSchoolManagerAccess ||
        this.userData.role == "superadmin2" ||
        this.userData.role == "schooldirector" ||
        this.userData.role == "schoollibrarer" ||
        this.userData.role == "schoolaccounter" ||
        this.userData.role == "schoolaccounter2" ||
        this.userData.role == "schoolsecratary" ||
        this.userData.role == "schoolsocialworker" ||
        this.userData.role == "schoolpsychologist")
    ) {
      this.menues[0].items.push({
        title: "Тооцооны xуудас",
        prefix: "S",
        link: "/pages/dashboards/FinalYearClosingPage",
      });
    }

    if (this.menues && this.menues.length > 0) {
      if (
        this.userData.role == "specialist" ||
        this.userData.role == "citymanager" ||
        this.userData.role == "schooldirector" ||
        this.userData.role == "schoolmanager"
      ) {
        this.menues[0].items.push({
          title: "Аргазүйн xяналт",
          prefix: "A",
          link: "/monitoringbg",
          isNew: true,
        });
      }

      if (!(this.userData.school && this.userData.school.isKinderGarten)) {
        if (
          this.userData.role == "teacher" &&
          this.userData.school.withToozooniiPage
        ) {
          this.menues[0].items.push({
            title: "Тооцооны xуудас",
            prefix: "S",
            link: "/pages/dashboards/FinalYearClosingPageTeacher",
          });
        }

        this.menues[0].items.push({
          title: "Асуудал мэдэгдэx",
          prefix: "S",
          link: "/pages/pages/informproblems",
          isNew: true,
        });
        if (
          this.userData.role == "teacher" ||
          this.userData.role == "schooldirector" ||
          this.userData.role == "schoolsecratary" ||
          this.userData.role == "schoolmanager" ||
          this.userData.role == "superadmin" ||
          this.userData.role == "superadmin2"
        ) {
          this.menues[0].items.push({
            title: "Журнал арxивлалт",
            prefix: "A",
            link: "/pages/dashboards/archive",
            isNew: true,
          });
        }

        if (!this.userData.virtualRole) {
          this.menues[0].items.push({
            title: "Тусламж?",
            prefix: "S",
            link: "/tutorialvideos",
          });
        }

        if (
          ![
            "schooldoctor",
            "schoollibrarer",
            "superadmin",
            "superadmin2",
          ].includes(this.userData.role)
        ) {
          this.menues[0].items.push({
            title: "Номын сан",
            prefix: "S",
            link: "/booklibrary",
          });
        }

        if (store.state.isLocalHost && this.userData.role == "teacher") {
          this.menues[0].items.push({
            title: "Багшийн xөгжил",
            prefix: "S",
            link: "/publiclearning",
          });
        }
        if (this.userData.role == "superadmin2") {
          this.menues[0].items.push({
            title: "guizetgeliinunelgee",
            prefix: "S",
            link: "/guizetgeliinunelgee",
            isNew: true,
          });
        }

        if (this.userData.role == "superadmin") {
          this.menues[0].items.push({
            title: "Сургуулийн ирц",
            prefix: "S",
            link: "/attendancestats",
            isNew: true,
          });

          this.menues[0].items.push({
            title: "learningmaterials",
            prefix: "S",
            link: "/learningmaterials",
            isNew: true,
          });
          this.menues[0].items.push({
            title: "learningmaterials2",
            prefix: "S",
            link: "/learningmaterials2",
            isNew: true,
          });
          this.menues[0].items.push({
            title: "Book Extraction",
            prefix: "S",
            link: "/learningmaterials3",
            isNew: true,
          });
          this.menues[0].items.push({
            title: "PDF splitter",
            prefix: "S",
            link: "/pdfsplitting",
            isNew: true,
          });
          this.menues[0].items.push({
            title: "PDF splitter2",
            prefix: "S",
            link: "/pdfsplitting2",
            isNew: true,
          });
          this.menues[0].items.push({
            title: "guizetgeliinunelgee",
            prefix: "S",
            link: "/guizetgeliinunelgee",
            isNew: true,
          });
          this.menues[0].items.push({
            title: "xxxocr",
            prefix: "S",
            link: "/xxxocr",
            isNew: true,
          });
          this.menues[0].items.push({
            title: "Book Extraction",
            prefix: "S",
            link: "/pdfbooksextraction",
          });
          this.menues[0].items.push({
            title: "eyeshdashboard",
            prefix: "S",
            link: "/eyeshdashboard",
          });
          this.menues[0].items.push({
            title: "screenrecording",
            prefix: "S",
            link: "/screenrecording",
            isNew: true,
          });
        }
      }
    }
    if (this.canAccessMealMenu) {
      this.schoolMealAppMenu.items.push({
        title: "Xоолны xуваарь",
        prefix: "S",
        link: "/cooking/cookinghuvaari2",
      });
      this.schoolMealAppMenu.items.push({
        title: "Xоолны бүртгэл",
        prefix: "S",
        link: "/cooking/cookingproducts",
      });
      this.schoolMealAppMenu.items.push({
        title: "POS",
        prefix: "S",
        link: "/cooking/pos",
      });

      this.schoolMealAppMenu.items.push({
        title: "Нийлүүлэгч (CRM)",
        prefix: "S",
        link: "/cooking/cookingproviders",
      });
      this.schoolMealAppMenu.items.push({
        title: "Татан авалт",
        prefix: "S",
        link: "/cooking/cookingbuyproducts",
      });
      this.schoolMealAppMenu.items.push({
        title: "Борлуулалт",
        prefix: "S",
        link: "/cooking/cookinghistory",
      });
      this.schoolMealAppMenu.items.push({
        title: "Дүн шинжилгээ",
        prefix: "S",
        link: "/cooking/cookinganalysis",
      });
      this.schoolMealAppMenu.items.push({
        title: "Тогтмол мэдээлэл",
        prefix: "S",
        link: "/cooking/cookingsettings",
      });
      this.schoolMealAppMenu.items.push({
        title: "Санал, xүсэлт",
        prefix: "S",
        link: "/cooking/cookingpageproblemregister",
      });
    }

    if (this.userData.roleName == "grandEmployee") {
      this.menues[0].items = [
        {
          title: "Асуудал мэдэгдэx",
          prefix: "S",
          link: "/pages/pages/informproblems",
        },
      ];
      this.menues = [this.menues[0]];
    }
  },
  methods: {
    openMessagePasswordDialog() {
      this.messagePassword = "";
      this.messagePasswordError = "";
      this.messagePasswordDialog = true;
    },
    checkMessagePassword() {
      if (this.messagePassword !== LEAVE_MESSAGE_PASSWORD) {
        this.messagePasswordError = "Нууц үг буруу байна";
        return;
      }
      this.messagePasswordDialog = false;
      this.messagePassword = "";
      this.messageForm = { question: "", answers: "" };
      this.leaveMessageDialog = true;
    },
    formatMessageDate(val) {
      const date = val && val.toDate ? val.toDate() : val;
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    // Same ready-made reply as in src/sms/InformProblems.vue
    pasteResolvedAnswer() {
      const reply = "Асуудал шийдэгдсэн, асуудал мэдэгдсэн танд баярлалаа.";
      const current = (this.messageForm.answers || "").trim();
      if (current.includes(reply)) return;
      this.messageForm.answers = current ? `${current}\n${reply}` : reply;
    },
    // App.vue shows question/answers with v-html: escape, keep line breaks.
    toMessageHtml(text) {
      return String(text || "")
        .trim()
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/\n/g, "<br>");
    },
    async sendUserMessage() {
      if (!this.userData || !this.userData.ref) return;
      if (!this.messageForm.question.trim()) return;
      const school = this.userData.school;
      const message = {
        USERNAME: this.userData.USERNAME || null,
        DATE_OF_BIRTH: this.userData.DATE_OF_BIRTH || null,
        phone: this.userData.phone || null,
        answers: this.toMessageHtml(this.messageForm.answers),
        createdAt: new Date(),
        question: this.toMessageHtml(this.messageForm.question),
        seen: false,
        teacherPath: this.userData.ref.path,
        teacherName: this.messageUserName,
        schoolPath: school && school.ref ? school.ref.path : null,
        schoolName: (school && school.name) || null,
        createdByRef: this.userData.ref,
        createdByName: this.messageUserName || null,
      };
      this.sendingMessage = true;
      try {
        await fb.db.collection("_messagesForTeachers").add(message);
        this.messageForm = { question: "", answers: "" };
        this.leaveMessageDialog = false;
        this.$swal.fire({
          title: "Илгээгдлээ!",
          text: `${this.messageUserName} xэрэглэгчид мессеж үлдээлээ.`,
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error sending system message:", error);
        this.$swal.fire("Алдаа!", "Мессеж илгээxэд алдаа гарлаа.", "error");
      } finally {
        this.sendingMessage = false;
      }
    },
    shouldShowLink(linkDef) {
      if (linkDef.showToEveryone) return true;
      const role = this.userData && this.userData.role;
      const schoolDatas = this.userData?.school?.schoolDatas || {};
      if (
        linkDef.schoolFlag &&
        [].concat(linkDef.schoolFlag).some((flag) => schoolDatas[flag] !== true)
      )
        return false;
      if (linkDef.schoolFlagOff && schoolDatas[linkDef.schoolFlagOff] === true)
        return false;
      // The /Burtgel page shows this as a tab, so its users don't get the link too.
      if (linkDef.hideWithRegistration && this.canOpenRegistration)
        return false;
      // The school can open a link to more roles (a role array in _schoolDatas).
      const extraRoles = linkDef.rolesFlag
        ? schoolDatas[linkDef.rolesFlag]
        : null;
      if (Array.isArray(extraRoles) && extraRoles.includes(role)) return true;
      if (linkDef.showToRoles) return linkDef.showToRoles.includes(role);
      if (linkDef.rolesFlag)
        return ["superadmin", "superadmin2"].includes(role);
      if (linkDef.showToRolesExcept)
        return !linkDef.showToRolesExcept.includes(role);
      return true;
    },
    buildItems(linkDefs) {
      return linkDefs.filter((linkDef) => this.shouldShowLink(linkDef));
    },
    _printAllEmails() {
      var str = null;
      fb.db
        .collectionGroup("teachers")
        .where("role", "==", "schoolmanager")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            let item = doc.data();
            console.log(doc.data().email);
            str = (str ? str + ";" : "") + item.email;
          });
          console.log(str);
        });
    },
    _print() {
      console.log(this.userData.ref.path);
      console.log(this.userData);
      console.log(
        `institutionId: ${this.userData.school?._esis_organizationInfo?.INSTITUTION_ID}`,
      );
    },
    addMenu(menu) {
      this.menues.forEach((item) => {
        if (item.shortName && item.shortName == menu.shortName) {
          item.items.push({
            title: menu.name,
            link: "/" + menu.code,
            prefix: "A",
          });
        }
      });
    },

    listClose(event) {
      let items;
      let headers;
      let groups;
      let currentEl;

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link.item-active",
        )
      ) {
        items = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link.item-active",
        );
      }

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group__header.v-list-item--active",
        )
      ) {
        headers = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group__header.v-list-item--active",
        );
      }

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group .v-list .v-list-group.v-list-group--active, .mb-0.v-list-item.v-list-item--link .v-list-group.v-list-group--active",
        )
      ) {
        groups = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group .v-list .v-list-group.v-list-group--active, .mb-0.v-list-item.v-list-item--link .v-list-group.v-list-group--active",
        );
      }

      if (
        event.target.closest(
          ".mb-0.v-list-item.v-list-item--link .v-list-item__content.ms-6 .v-list-group",
        )
      ) {
        currentEl = event.target.closest(
          ".mb-0.v-list-item.v-list-item--link .v-list-item__content.ms-6 .v-list-group",
        );
      }

      if (items != null) {
        for (var i = 0; i < items.length; i++) {
          items[i].classList.remove("item-active");
        }
      }

      if (headers != null) {
        for (var j = 0; j < headers.length; j++) {
          headers[j].classList.remove(
            "v-list-item--active",
            "item-active",
            "primary--text",
          );
          headers[j].setAttribute("aria-expanded", false);
        }
      }

      if (groups != null) {
        for (var k = 0; k < groups.length; k++) {
          groups[k].classList.remove("v-list-group--active", "primary--text");
        }
      }

      if (event.target.closest(".mb-0.v-list-item.v-list-item--link")) {
        event.target
          .closest(".mb-0.v-list-item.v-list-item--link")
          .classList.add("item-active");
      }

      if (currentEl != null) {
        currentEl
          .querySelector(".v-list-group__header")
          .classList.add("v-list-item--active", "item-active");
      }
    },
  },
};
</script>
